import React from 'react'

import { InstitutionLogo, Text } from '@mxenabled/mxui'

import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { Card, CardHeader, Box, Stack, IconButton, Button, useTheme } from '@mui/material'

import { copy } from '../../Copy'

export type FeedSize = 'full' | 'mini' | 'micro'

export interface InsightPreviewCardProps {
  feedSize: FeedSize
  title?: string
  description?: string
  cta?: string
}

export default function InsightPreviewCard({
  feedSize,
  title = '',
  description = '',
  cta = '',
}: InsightPreviewCardProps) {
  const theme = useTheme()

  const isMicro = feedSize === 'micro'
  const isFull = feedSize === 'full'

  return (
    <Card
      sx={{
        border: '1.5px dashed ' + theme.palette.primary[500],
        borderRadius: '8px',
        boxShadow: theme.shadows[2],
        backgroundColor: isMicro ? 'transparent' : theme.palette.background.paper,
        minHeight: 124,
        padding: 16,
        width: 350,
      }}
    >
      <CardHeader
        action={
          isFull && (
            <IconButton size="small">
              <MoreHorizIcon />
            </IconButton>
          )
        }
        sx={{ padding: 0 }}
        title={
          isMicro ? (
            <Box alignItems="center" display="flex">
              <InstitutionLogo
                alt={copy.preview_card_logo_alt}
                institutionGuid="INS-3aeb38da-26e4-3818-e0fa-673315ab7754"
                size={20}
              />
              <Text color="text.secondary" fontWeight={700} marginLeft={8}>
                {title}
              </Text>
            </Box>
          ) : (
            <Text color="text.secondary" fontWeight={700} variant="h3">
              {title}
            </Text>
          )
        }
      />
      <Stack height={12} />
      <Stack>
        <Text
          color="text.secondary"
          marginLeft={isMicro ? 28 : 0}
          truncate={isMicro ? true : false}
          variant="subtitle2"
        >
          {description}
        </Text>
        {isFull && cta.length > 0 && (
          <>
            <Stack height={16} />
            <Button fullWidth disabled={true} variant="outlined">
              {cta}
            </Button>
          </>
        )}
        {isMicro && (
          <Text color="primary" fontWeight={700} marginLeft={28} marginTop={16} variant="subtitle2">
            {copy.preview_card_read_more}
          </Text>
        )}
      </Stack>
    </Card>
  )
}
